const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const Asset = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/Asset');
const Warehousing = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/warehousing/Index');
const WarehousingDetail = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/warehousing/Detail');
const WarehousingAssetFill = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/warehousing/AssetFill');
const Acquisition = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/acquisition/Index');
const AcquisitionDetail = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/acquisition/Detail');
const Restitution = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/restitution/Index');
const RestitutionDetail = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/restitution/Detail');
const Repairment = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/repairment/Index');
const RepairmentDetail = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/repairment/Detail');
const Scrap = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/scrap/Index');
const ScrapDetail = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/scrap/Detail');
const AssetCreatePage = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/AssetCreatePage');
const AssetDetail = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/AssetDetail');
const CreateAssetRelevant = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/CreateAssetRelevant');
const CreateContractRelevant = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/CreateContractRelevant');

export default [
  {
    path: '/asset-manage',
    name: 'assetManage',
    component: Layout,
    meta: {
      title: '资产管理',
      icon: 'asset',
      roles: ['SYS_ASSET_QUERY']
    },
    children: [
      {
        path: 'asset-bench',
        name: 'asset',
        meta: {
          title: '资产列表',
          roles: ['SYS_ASSET_QUERY'],
          componentName: 'Asset',
          breadcrumb: [
            {
              name: '资产列表',
              path: '/asset-manage/asset-bench'
            }
          ]
        },
        component: Asset
      },
      {
        path: 'warehousing',
        name: 'warehousing',
        meta: {
          title: '资产入库',
          roles: ['ASSET_WAREHOUSING_QUERY'],
          componentName: 'Warehousing',
          breadcrumb: [
            {
              name: '资产入库',
              path: '/asset-manage/warehousing'
            }
          ]
        },
        component: Warehousing
      },
      {
        path: 'create-warehousing',
        name: 'createWarehousing',
        meta: {
          title: '新增入库单',
          roles: ['ASSET_WAREHOUSING_ADD'],
          activeMenu: '/asset-manage/warehousing',
          componentName: 'WarehousingDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '新增入库单',
              path: '/asset-manage/create-warehousing'
            }
          ]
        },
        component: WarehousingDetail
      },
      {
        path: 'edit-warehousing/:id',
        name: 'editWarehousing',
        meta: {
          title: '编辑入库单',
          roles: ['ASSET_WAREHOUSING_DETAIL_QUERY'],
          activeMenu: '/asset-manage/warehousing',
          componentName: 'WarehousingDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '编辑入库单',
              path: '/asset-manage/edit-warehousing/:id'
            }
          ]
        },
        component: WarehousingDetail
      },
      {
        path: 'warehousing-asset-fill/:id',
        name: 'warehousingAssetFill',
        meta: {
          title: '资产入库',
          roles: ['ASSET_WAREHOUSING_PUT_IN'],
          activeMenu: '/asset-manage/warehousing',
          componentName: 'WarehousingAssetFill',
          hidden: true,
          breadcrumb: [
            {
              name: '资产入库',
              path: '/asset-manage/warehousing-asset-fill/:id'
            }
          ]
        },
        component: WarehousingAssetFill
      },
      {
        path: 'acquisition',
        name: 'acquisition',
        meta: {
          title: '资产领用',
          roles: ['ASSET_ACQUISITION_QUERY'],
          componentName: 'Acquisition',
          breadcrumb: [
            {
              name: '资产领用',
              path: '/asset-manage/acquisition'
            }
          ]
        },
        component: Acquisition
      },
      {
        path: 'create-acquisition',
        name: 'createAcquisition',
        meta: {
          title: '新增领用单',
          roles: ['ASSET_ACQUISITION_ADD'],
          activeMenu: '/asset-manage/acquisition',
          componentName: 'AcquisitionDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '新增领用单',
              path: '/asset-manage/create-acquisition'
            }
          ]
        },
        component: AcquisitionDetail
      },
      {
        path: 'edit-acquisition/:id',
        name: 'editAcquisition',
        meta: {
          title: '编辑领用单',
          roles: ['ASSET_ACQUISITION_DETAIL_QUERY'],
          activeMenu: '/asset-manage/acquisition',
          componentName: 'AcquisitionDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '编辑领用单',
              path: '/asset-manage/edit-acquisition/:id'
            }
          ]
        },
        component: AcquisitionDetail
      },
      {
        path: 'restitution',
        name: 'restitution',
        meta: {
          title: '资产归还',
          roles: ['ASSET_RESTITUTION_QUERY'],
          componentName: 'Restitution',
          breadcrumb: [
            {
              name: '资产归还',
              path: '/asset-manage/restitution'
            }
          ]
        },
        component: Restitution
      },
      {
        path: 'create-restitution',
        name: 'createRestitution',
        meta: {
          title: '新增归还单',
          roles: ['ASSET_RESTITUTION_ADD'],
          activeMenu: '/asset-manage/restitution',
          componentName: 'RestitutionDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '新增归还单',
              path: '/asset-manage/create-restitution'
            }
          ]
        },
        component: RestitutionDetail
      },
      {
        path: 'edit-restitution/:id',
        name: 'editRestitution',
        meta: {
          title: '编辑归还单',
          roles: ['ASSET_RESTITUTION_DETAIL_QUERY'],
          activeMenu: '/asset-manage/restitution',
          componentName: 'RestitutionDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '编辑归还单',
              path: '/asset-manage/edit-restitution/:id'
            }
          ]
        },
        component: RestitutionDetail
      },
      {
        path: 'repairment',
        name: 'repairment',
        meta: {
          title: '资产报修',
          roles: ['ASSET_REPAIRMENT_QUERY'],
          componentName: 'Repairment',
          breadcrumb: [
            {
              name: '资产报修',
              path: '/asset-manage/repairment'
            }
          ]
        },
        component: Repairment
      },
      {
        path: 'create-repairment',
        name: 'createRepairment',
        meta: {
          title: '新增报修单',
          roles: ['ASSET_REPAIRMENT_ADD'],
          activeMenu: '/asset-manage/repairment',
          componentName: 'RepairmentDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '新增报修单',
              path: '/asset-manage/create-repairment'
            }
          ]
        },
        component: RepairmentDetail
      },
      {
        path: 'edit-repairment/:id',
        name: 'editRepairment',
        meta: {
          title: '编辑报修单',
          roles: ['ASSET_REPAIRMENT_DETAIL_QUERY'],
          activeMenu: '/asset-manage/repairment',
          componentName: 'RepairmentDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '编辑报修单',
              path: '/asset-manage/edit-repairment/:id'
            }
          ]
        },
        component: RepairmentDetail
      },
      {
        path: 'scrap',
        name: 'scrap',
        meta: {
          title: '资产报废',
          roles: ['ASSET_SCRAP_QUERY'],
          componentName: 'Scrap',
          breadcrumb: [
            {
              name: '资产报废',
              path: '/asset-manage/scrap'
            }
          ]
        },
        component: Scrap
      },
      {
        path: 'create-scrap',
        name: 'createScrap',
        meta: {
          title: '新增报废单',
          roles: ['ASSET_SCRAP_ADD'],
          activeMenu: '/asset-manage/scrap',
          componentName: 'ScrapDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '新增报废单',
              path: '/asset-manage/create-scrap'
            }
          ]
        },
        component: ScrapDetail
      },
      {
        path: 'edit-scrap/:id',
        name: 'editScrap',
        meta: {
          title: '编辑报废单',
          roles: ['ASSET_SCRAP_DETAIL_QUERY'],
          activeMenu: '/asset-manage/scrap',
          componentName: 'ScrapDetail',
          hidden: true,
          breadcrumb: [
            {
              name: '编辑报废单',
              path: '/asset-manage/edit-scrap/:id'
            }
          ]
        },
        component: ScrapDetail
      },
      {
        path: 'edit-asset/:id',
        props: true,
        name: 'editAsset',
        meta: {
          title: '编辑资产',
          hidden: true,
          activeMenu: '/asset-manage/asset-bench',
          roles: ['SYS_ASSET_DETAIL_QUERY'],
          componentName: 'AssetDetail',
          breadcrumb: [
            {
              name: '资产管理',
              path: '/asset-manage/asset-bench'
            },
            {
              name: '编辑资产',
              path: '/asset-manage/edit-asset/:id'
            }
          ]
        },
        component: AssetDetail
      },
      {
        path: 'create-asset',
        name: 'createAsset',
        meta: {
          title: '新建资产',
          hidden: true,
          activeMenu: '/asset-manage/asset-bench',
          roles: ['SYS_ASSET_ADD'],
          componentName: 'AssetCreatePage',
          breadcrumb: [
            {
              name: '资产管理',
              path: '/asset-manage/asset-bench'
            },
            {
              name: '新建资产',
              path: '/asset-manage/create-asset'
            }
          ]
        },
        component: AssetCreatePage
      },
      {
        path: ':id/create-asset-relevant',
        props: true,
        name: 'createAssetRelevant',
        meta: {
          title: '关联资产',
          hidden: true,
          activeMenu: '/asset-manage/asset-bench',
          roles: ['SYS_ASSET_RELEVANT_QUERY'],
          componentName: 'CreateAssetRelevant',
          breadcrumb: [
            {
              name: '资产管理',
              path: '/asset-manage/asset-bench'
            },
            {
              name: '关联资产',
              path: '/asset-manage/:id/create-relevant'
            }
          ]
        },
        component: CreateAssetRelevant
      },
      {
        path: ':id/create-contract-relevant',
        props: true,
        name: 'createContractRelevant',
        meta: {
          title: '关联合同',
          hidden: true,
          activeMenu: '/asset-manage/asset-bench',
          roles: ['SYS_ASSET_CONTRACT_QUERY'],
          componentName: 'CreateContractRelevant',
          breadcrumb: [
            {
              name: '资产管理',
              path: '/asset-manage/asset-bench'
            },
            {
              name: '关联合同',
              path: '/asset-manage/:id/create-contract-relevant'
            }
          ]
        },
        component: CreateContractRelevant
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/asset.js